
import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav style={{display:"flex",gap:12,padding:12,borderBottom:"1px solid #eee"}}>
      <strong>Sudpang1688</strong>
      <Link to="/dashboard">Dashboard</Link>
      <Link to="/login">Login</Link>
      <Link to="/register">Register</Link>
    </nav>
  );
}
